import { createCrudApi } from 'src/shared/api/crudApi';
import { API_PREFIX } from 'src/shared/constants';
import type { ExpenseCategory, ExpenseCategoryListParams, ExpenseCategoryPayload } from './types';

/**
 * The expense categories. `remove` is generated but never called: the API has
 * no DELETE for a category, which is archived with `update({ isActive: false })`.
 */
export const expenseCategoriesApi = createCrudApi<
  ExpenseCategory,
  ExpenseCategoryListParams,
  ExpenseCategoryPayload,
  ExpenseCategoryPayload
>(`${API_PREFIX}/expense-categories`);
